import { AndroidDigitalWalletCard, DigitalWalletTokenStatus } from '@generated-types';

import { debitCard1Mock } from './debitCards';

export const mockGoogleWalletEligibleCard1: AndroidDigitalWalletCard = {
    status: DigitalWalletTokenStatus.ELIGIBLE,
    eikaCardId: debitCard1Mock.id,
    productId: 2351,
    tokenUniqueReference: 'unique reference toekn',
};
